import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError, defaultIfEmpty } from 'rxjs/operators';
import { PermissionsService } from '../services/permissions.service';
import { BriTeammateAuthorizationService } from '@davita/bridge-utility-library/authorization';

export const authoroziedUserGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);
  const briTeammateAuthorizationService = inject(BriTeammateAuthorizationService);

  return permissionsService.isAuthorizedUser().pipe(
    defaultIfEmpty(false),
    map((isAuthorizedUser) => {
        console.log(isAuthorizedUser);
        console.log("Calling Authorized user service")
      if (isAuthorizedUser) {
        return true;
      }
      
      briTeammateAuthorizationService.logout();
      return router.createUrlTree(['/login']);
    }),
    catchError(() => {
      briTeammateAuthorizationService.logout();
      return of(router.createUrlTree(['/login']));
    })
  );
};